import React, { useState, useEffect, useRef } from 'react';
import { ProgressBar } from 'react-bootstrap';
import TrackedTime from './TrackedTime';
import Timegraph from '../Dashboard/Timegraph';
import { commonGetService, handleFilterApi } from '../../utils/properties';
import { ActivityTimes, HoursTracked } from '../../pages/Dashboard';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { showToast } from '../../features/Toaster/toastslice';
import Barcharts from '../BarCharts/Barcharts';
import { InsigtsData, InsigtsData1 } from '../Dashboard/ProductiveDetails';
import TimeLine from '../TimelineCharts/TimeLine';
import { useParams } from 'react-router';

export interface EmployeeActivityTimes extends ActivityTimes {

}

const Overview = () => {
    const [hoursTracked, setHoursTracked] = useState<HoursTracked[]>([]);
    const [isChartLoading, setIsChartLoading] = useState<boolean>(false);
    const [insightsData, setInsightsData] = useState<InsigtsData[]>([]);
    const [insightsLoading, setInsightsLoading] = useState<boolean>(false);
    const [activityDetails, setActivityDetails] = useState<EmployeeActivityTimes>();

    const { empid } = useParams();

    const filterData = useAppSelector((state) => state.filterData);
    const { startDate, endDate, empDeviceId, filterType, organization, department } = filterData; // Destructuring the filterData state value
    const dispatch = useAppDispatch();

    const prevFilters = useRef("");



    useEffect(() => {
        if (!empDeviceId || !startDate || !endDate) return;

        const currentFilters = `${empDeviceId}-${startDate}-${endDate}`;

        if (prevFilters.current === currentFilters) return;

        prevFilters.current = currentFilters;

        getHoursTracked();
        getInsightsData();
        getActivityDetails();

    }, [empDeviceId, startDate, endDate, empid]);

    const getHoursTracked = () => {
        setIsChartLoading(true);
        commonGetService(
            `/api/1.0/dashboard/tracked/hours?${handleFilterApi(startDate, endDate, filterType, organization, empid ?? empDeviceId, department, true)}`
        ).then((res) => {
            setIsChartLoading(false);
            if (res?.status === 200) {
                setHoursTracked(res?.data);
            }
            else {
                dispatch(
                    showToast({
                        message: "Something went wrong in API.",
                        status: "retry",
                        visible: true,
                    })
                );
            }
        });
    };

    const getInsightsData = () => {
        if (filterType !== "employee") {
            setInsightsLoading(true);
            commonGetService(
                `/api/1.0/dashboard/department/insights?${handleFilterApi(
                    startDate,
                    endDate,
                    filterType,
                    organization,
                    empid ?? empDeviceId,
                    department,
                    false
                )}`
            ).then((res) => {
                setInsightsLoading(false);
                if (res.status === 200) {
                    let formatedData = res?.data?.map((val: InsigtsData) => {
                        return {
                            Department: val?.department,
                            Productive: val?.productive_hours,
                            Unproductive: val?.unproductive_hours,
                            Idle: val?.idle_hours,
                            Neutral: val?.neutral_hours,
                            total_hours: val?.total_hours,
                        };
                    });
                    setInsightsData(formatedData);
                }
                else {
                    dispatch(
                        showToast({
                            message: "Something went wrong in API.",
                            status: "retry",
                            visible: true,
                        })
                    );
                }
            });
        } else {
            setInsightsLoading(true);
            commonGetService(
                `/api/1.0/dashboard/productivity/insights?${handleFilterApi(
                    startDate,
                    endDate,
                    filterType,
                    organization,
                    empid ?? empDeviceId,
                    department,
                    false
                )}`
            ).then((res) => {
                setInsightsLoading(false);
                if (res.status === 200) {
                    let formatedData = res?.data?.map((val: InsigtsData1) => {
                        return {
                            day: val?.day,
                            timestamp: val?.timestamp,
                            Productive: val?.productive_hours,
                            Unproductive: val?.unproductive_hours,
                            Idle: val?.idle_hours,
                            Neutral: val?.neutral_hours,
                            total_hours: val?.total_hours,
                        };
                    });
                    setInsightsData(formatedData);
                }
                else {
                    dispatch(
                        showToast({
                            message: "Something went wrong in API.",
                            status: "retry",
                            visible: true,
                        })
                    );
                }
            });
        }
    };
    const getActivityDetails = () => {
        commonGetService(`/api/1.0/dashboard/trends?${handleFilterApi(startDate, endDate, filterType, organization, empid ?? empDeviceId, department, false)}`).then((res) => {
            if (res?.status === 200) {
                setActivityDetails(res?.data);
            }
            else {
                dispatch(
                    showToast({
                        message: "Something went wrong in API.",
                        status: "retry",
                        visible: true,
                    })
                );
            }
        });
    };

    return (
        <div className='emp-overview'>
            <div className='emp-activity w-100'>
                <div className='total-time'>
                    <h5>Total time tracked</h5>
                    <p>{activityDetails?.total_time}</p>
                </div>
                <div className='divider'>
                    <div></div>
                </div>
                <TrackedTime
                    title='Total active time'
                    hoursTracked={activityDetails?.productive_time ?? ""}
                    percentageValue={activityDetails?.productive_percentage ?? ""}
                    isActive={true}
                />
                <div className='divider'>
                    <div></div>
                </div>
                <TrackedTime
                    title='Total passive time'
                    hoursTracked={activityDetails?.unproductive_time ?? ""}
                    percentageValue={activityDetails?.unproductive_percentage ?? ""}
                    isActive={true}
                />
                <div className='divider'>
                    <div></div>
                </div>
                <TrackedTime
                    title='Total neutral time'
                    hoursTracked={activityDetails?.neutral_time ?? ""}
                    percentageValue={activityDetails?.neutral_percentage ?? ""}
                    isActive={true}
                />
                <div className='divider'>
                    <div></div>
                </div>
                <TrackedTime
                    title='Total idle time'
                    hoursTracked={activityDetails?.idle_time ?? ""}
                    percentageValue={activityDetails?.idle_time_percentage?.toString() ?? ""} isActive={false}
                />
            </div>
            <div className='comp-box'>
                <TimeLine />
            </div>
            <div className='comp-box'>
                <Timegraph
                    trackedHours={hoursTracked}
                    chartLoading={isChartLoading}
                />
            </div>
            <div className='comp-box p-3 styled-scroll-hor'>
                <Barcharts
                    insightsData={insightsData}
                    chartLoading={insightsLoading}
                />
            </div>
        </div>
    );
};

export default Overview;